var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { attrs: { id: "headerDiv" } }, [
      _c(
        "div",
        { attrs: { id: "headDiv" } },
        [
          _c("v-autocomplete", {
            staticStyle: { "min-width": "22vh", "margin-right": "30px" },
            attrs: {
              multiple: "",
              items: _vm.fleets,
              "item-text": "nombre",
              "item-value": "id",
              "append-icon": "",
              label: "Búsqueda por flotas",
              chips: "",
              "deletable-chips": "",
              "search-input": _vm.searchFleets
            },
            on: {
              "update:searchInput": function($event) {
                _vm.searchFleets = $event
              },
              "update:search-input": function($event) {
                _vm.searchFleets = $event
              },
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                ) {
                  return null
                }
                return _vm.updateTagsFleets($event)
              }
            },
            scopedSlots: _vm._u([
              {
                key: "selection",
                fn: function(ref) {
                  var item = ref.item
                  var index = ref.index
                  return [
                    index === 0
                      ? _c("v-chip", [
                          _c("span", [
                            _vm._v(_vm._s(_vm.textoComprimido(item.nombre)))
                          ])
                        ])
                      : _vm._e(),
                    index === 1
                      ? _c("span", { staticClass: "grey--text caption" }, [
                          _vm._v(
                            "(+" +
                              _vm._s(_vm.fleetsSelected.length - 1) +
                              " otros)"
                          )
                        ])
                      : _vm._e()
                  ]
                }
              }
            ]),
            model: {
              value: _vm.fleetsSelected,
              callback: function($$v) {
                _vm.fleetsSelected = $$v
              },
              expression: "fleetsSelected"
            }
          }),
          _c(
            "div",
            {
              on: {
                click: function($event) {
                  _vm.dateStartDialog = true
                }
              }
            },
            [
              _c("v-combobox", {
                staticStyle: { "max-width": "22vh", "margin-right": "30px" },
                attrs: {
                  label: "Fecha inicial",
                  chips: "",
                  readonly: "",
                  "prepend-icon": "event",
                  "deletable-chips": ""
                },
                model: {
                  value: _vm.dateStartSelected,
                  callback: function($$v) {
                    _vm.dateStartSelected = $$v
                  },
                  expression: "dateStartSelected"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              on: {
                click: function($event) {
                  _vm.dateEndDialog = true
                }
              }
            },
            [
              _c("v-combobox", {
                staticStyle: { "max-width": "22vh", "margin-right": "30px" },
                attrs: {
                  label: "Fecha final",
                  "prepend-icon": "event",
                  chips: "",
                  readonly: "",
                  "deletable-chips": ""
                },
                model: {
                  value: _vm.dateEndSelected,
                  callback: function($$v) {
                    _vm.dateEndSelected = $$v
                  },
                  expression: "dateEndSelected"
                }
              })
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "290" },
              model: {
                value: _vm.dateStartDialog,
                callback: function($$v) {
                  _vm.dateStartDialog = $$v
                },
                expression: "dateStartDialog"
              }
            },
            [
              _c("v-date-picker", {
                attrs: {
                  range: "",
                  events: _vm.dateEndArray,
                  "event-color": "#27488E",
                  max: _vm.dateEndSelected,
                  "allowed-dates": _vm.allowedDates
                },
                on: {
                  change: function($event) {
                    _vm.dateStartDialog = false
                  }
                },
                model: {
                  value: _vm.dateStartSelected,
                  callback: function($$v) {
                    _vm.dateStartSelected = $$v
                  },
                  expression: "dateStartSelected"
                }
              })
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "290" },
              model: {
                value: _vm.dateEndDialog,
                callback: function($$v) {
                  _vm.dateEndDialog = $$v
                },
                expression: "dateEndDialog"
              }
            },
            [
              _c("v-date-picker", {
                attrs: {
                  range: "",
                  events: _vm.dateStartArray,
                  "event-color": "#27488E",
                  min: _vm.dateStartSelected,
                  "allowed-dates": _vm.allowedDates
                },
                on: {
                  change: function($event) {
                    _vm.dateEndDialog = false
                  }
                },
                model: {
                  value: _vm.dateEndSelected,
                  callback: function($$v) {
                    _vm.dateEndSelected = $$v
                  },
                  expression: "dateEndSelected"
                }
              })
            ],
            1
          ),
          _c("v-combobox", {
            staticStyle: { "min-width": "24vh", "margin-right": "30px" },
            attrs: {
              multiple: "",
              label: "Búsqueda por patentes",
              chips: "",
              "deletable-chips": "",
              "search-input": _vm.searchPatents
            },
            on: {
              "update:searchInput": function($event) {
                _vm.searchPatents = $event
              },
              "update:search-input": function($event) {
                _vm.searchPatents = $event
              }
            },
            model: {
              value: _vm.patentValues,
              callback: function($$v) {
                _vm.patentValues = $$v
              },
              expression: "patentValues"
            }
          }),
          _c(
            "div",
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "#27488E", fab: "", small: "", dark: "" },
                  on: { click: _vm.valideChanges }
                },
                [_c("v-icon", [_vm._v("search")])],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]),
    _c(
      "div",
      { attrs: { id: "bodyDiv" } },
      [
        _c(
          "v-card",
          {
            staticClass: "idCard",
            on: {
              mouseover: function($event) {
                _vm.mousePointKilometer = true
              },
              mouseleave: function($event) {
                _vm.mousePointKilometer = false
              }
            }
          },
          [
            _c("div", { staticClass: "idcardTitle" }, [
              _c("p", { staticClass: "titleCards" }, [
                _vm._v("Informe Kilometraje Compartir")
              ]),
              _c(
                "div",
                { staticClass: "exportButton" },
                [
                  _c("exportMenu", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.mousePointKilometer,
                        expression: "mousePointKilometer"
                      }
                    ],
                    attrs: { type: "kilometer" },
                    on: {
                      point: function($event) {
                        _vm.mousePointKilometer = true
                      },
                      exportData: _vm.exportData
                    }
                  })
                ],
                1
              )
            ]),
            _c("ag-grid-vue", {
              staticClass: "ag-theme-material",
              staticStyle: { width: "100%", height: "57.1vh" },
              attrs: {
                columnDefs: _vm.columnDefsKilometer,
                rowData: _vm.rowDataKilometer,
                gridOptions: _vm.gridOptionKilometer
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }